import React, { MouseEvent, useCallback } from 'react'

import * as Bridge from '@/api/BridgeApi'
import { CONTAINER_STYLE, MainContainer } from '@/components/common/container/MainContainer'
import { Header } from '@/components/common/header/Header'
import { useBackButton } from '@/hooks/useBackButton'
import { useTrans } from '@/hooks/useTrans'

export const EnforcedMessagePageError = () => {
  const $ = useTrans()

  useBackButton(() => {})

  const onClick = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    Bridge.closeWebView()
  }, [])

  return (
    <>
      <Header />
      <MainContainer style={CONTAINER_STYLE.NO_MARGIN}>
        <div className="enforced">
          <div className="enforced__scroll">
            <h1 className="enforced__tit">{$('enforced_server_fixing_title')}</h1>
            <div className="enforced__dsc">{$('enforced_server_fixing_desc')}</div>
          </div>
        </div>
        <div className="enforced__btn">
          <a href="/#" className="btn btn--gr btn--large" onClick={onClick}>
            {$('enforced_exit_button')}
          </a>
        </div>
      </MainContainer>
    </>
  )
}
